var restorepassword = {
    restore: "RESTABLECER CONTRASEÑA",
    eyebrowLabel: "Actualización segura de contraseña",
    text1: "Ingresa tu nueva contraseña",
    text2: "Crea una contraseña segura para recuperar el acceso a tu cuenta.",
    panelTitle: "Elige una nueva contraseña",
    panelText: "Usa al menos 8 caracteres y asegúrate de que ambos campos coincidan antes de guardar el cambio.",
    login: "Acceso",
    newpass: "Contraseña Nueva:",
    renewpass: "Confirmar contraseña:",
    newpassPlaceholder: "Ingresa tu nueva contraseña",
    renewpassPlaceholder: "Confirma tu nueva contraseña",
    sendbtn: "Guardar",
    saving: "Guardando...",
    error: "error: Confirmar contraseña no coincide",
    msg: "Su contraseña ha sido cambiada, vaya a Iniciar sesión para obtener acceso nuevamente",
    loginbtn: "Acceso",
    errorpage: "ERROR EN LA PAGINA",
    errortext1: "se debe de seguir el proceso correcto para cambio de contraseña",
    errorgo: "Porfavor, regresa a la pagina de Inicio",
    errorbtn: "Inicio",
    requiredNewPassword: "La nueva contraseña es obligatoria.",
    requiredRepeatPassword: "Confirma tu nueva contraseña.",
    passwordMinLength: "La contraseña debe tener al menos 8 caracteres.",
    passwordMismatch: "Las contraseñas no coinciden.",
    successTitle: "Contraseña actualizada",
    successText: "Tu contraseña se cambió correctamente. Ahora puedes volver a iniciar sesión con tu nueva contraseña.",
    successHelp: "Por seguridad, usa tu nueva contraseña la próxima vez que ingreses.",
    invalidLinkTitle: "Este enlace para restablecer contraseña no es válido",
    invalidLinkText: "Debes seguir el proceso correcto de restablecimiento de contraseña antes de crear una nueva contraseña.",
    invalidLinkHelp: "Vuelve al inicio o solicita un nuevo enlace desde la pantalla de olvidé mi contraseña.",
    message_error_pass_1:"se ha detectado un error al solicitar el cambio de contraseña, inténtelo más tarde", 
    success_password_changed:"Su contraseña ha sido cambiada, vaya a Iniciar sesión para obtener acceso nuevamente"
}
module.exports = restorepassword
